import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "tippy.js/dist/tippy.css";
import { ReactComponent as DeleteIcon } from "../../../assets/utils/images/svgs/Delete.svg";
import ReactTableGenericForUsers from "Components/ReactTableGenericForUsers";
import SweetAlert from "react-bootstrap-sweetalert";
import { Spinner } from "reactstrap";
import GroupStatus from "../Rollen/GroupState";
import { toast } from "react-toastify";
import UserModal from "./UserModal";
import { useDeleteRole, useUpdateRole, useUsers } from "Api/Admin/Rollen";

const List = ({ setShowModal, showModal }) => {
	const [pageSizeCount, setPageSizeCount] = useState(20);
	const [pageNumber, setPageNumber] = useState(1);
	const [searchValue, setSearchValue] = useState("");
	const [showAlert, setShowAlert] = useState(false);
	const [activeRowIndex, setActiveRowIndex] = useState({});
	const [loadingKeys, setLoadingKeys] = useState({});
	const [rowSaved, setRowSaved] = useState([]);
	const { trigger: updateRole } = useUpdateRole();
	const { trigger: deleteRole } = useDeleteRole();
	// const isFirstRender = useRef(true);


	useEffect(() => {
		// if (isFirstRender.current) {
		// 	isFirstRender.current = false;
		// 	return;
		// }
		if (!showModal) {
			mutate();
		}
	}, [showModal]);


	const {
		data: response,
		isLoading,
		mutate,
	} = useUsers(
		pageNumber,
		pageSizeCount,
		searchValue
	);

	const data = response?.data?.lists || [];
	const totalPageCount = response?.data?.pageCount || 0;
    const totalCount=response?.data?.totalCount
	const paginate = (val) => {
		setPageNumber(val);
	};


	const handleInputChange = (val) => {
		setPageNumber(1);
		setSearchValue(val);
	};

	const filterList = (val) => {
		handleInputChange(val);
	};

	const indexPageSize = (val) => {
		setPageSizeCount(val);
	};

	const userTablePageSize = (val) => {
		setPageNumber(1);
		indexPageSize(val);
	};

	const columns = useMemo(() => {
		return [
			{
				header: "Clooser-Id",
				accessorKey: "iAdminId",
			},
			{
				header: "Naam",
				accessorKey: "Naam",
				cell: (value) => {
					return <div className="">
						{value.row.original?.vLastName} {value.row.original?.vFirstName} {value.row.original?.vMiddleName}
					</div>
				}
			},
			{
				header: <div className="text-center">Administrator</div>,
				accessorKey: "administrator",
				cell: (value) => {
					const isRoleAdministrator = value.row.original?.roles.some((item) => (item.roleName === "administrator" && item.bIsEnabled === 1))
					return <div className="cursor-pointer ">
						{

							loadingKeys["administrator"] && loadingKeys["id"] === value.row?.original.iAdminId ? (
								<div className="spinner-icon-change">
									<div><Spinner size="sm" color="primary" /></div>
								</div>
							) :
								(
									<GroupStatus iconChangeHandler={(field, data) => iconHandler(value.row.original?.iAdminId, field, data)} field={"administrator"} data={isRoleAdministrator ? 1 : 0} />
								)
						}
					</div>
				},
			},
			{
				header: <div className="text-center">Support</div>,
				accessorKey: "support",
				cell: (value) => {
					const isRoleSupport = value.row.original?.roles.some((item) => (item.roleName === "support" && item.bIsEnabled === 1))
					return <div className="cursor-pointer ">
						{

							loadingKeys["support"] && loadingKeys["id"] === value.row?.original.iAdminId ? (
								<div className="spinner-icon-change">
									<div><Spinner size="sm" color="primary" /></div>
								</div>
							) :
								(
									<GroupStatus iconChangeHandler={(field, data) => iconHandler(value.row.original?.iAdminId, field, data)} field={"support"} data={isRoleSupport ? 1 : 0} />
								)
						}
					</div>
				},
			},
			{
				header: <div className="text-center">Documentenbeheer</div>,
				accessorKey: "documentbeheer",
				cell: (value) => {
					const isRoleDocumentbeheer = value.row.original?.roles.some((item) => (item.roleName === "documentbeheer" && item.bIsEnabled === 1))
					return <div className="cursor-pointer">
						{

							loadingKeys["documentbeheer"] && loadingKeys["id"] === value.row?.original.iAdminId ? (
								<div className="spinner-icon-change">
									<div><Spinner size="sm" color="primary" /></div>
								</div>
							) :
								(
									<GroupStatus iconChangeHandler={(field, data) => iconHandler(value.row.original?.iAdminId, field, data)} field={"documentbeheer"} data={isRoleDocumentbeheer ? 1 : 0} />
								)
						}
					</div>
				},
			},
			{
				header: <div className="text-center">Verwijderen</div>,
				accessorKey: "Verwijderen",
				cell: (value) => {
					return <div className="cursor-pointer ">
						<DeleteIcon onClick={() => {
							setShowAlert(true);
							setActiveRowIndex(value.row.original);
						}} />
					</div>
				},
			},
		];
	}, [data, loadingKeys])


	const iconHandler = (iAdminId, field, data) => {
		setLoadingKeys(prevLoadingKeys => {
			const updatedLoadingKeys = Object.fromEntries(
				Object.entries(prevLoadingKeys).filter(([_, value]) => value !== false)
			);

			return { ...updatedLoadingKeys, [field]: true, id: iAdminId };
		});

		const payload = {
			"iAdminId": iAdminId,
			"roleType": field,
			"enable": data
		}

		updateRole({
			method: "post",
			data: payload
		}).then((response) => {
			if (response?.status) {
				mutate();
			} else {
				toast.error("Kan gegevens niet updaten")
			}
		}).catch(() => {
			toast.error("Kan gegevens niet updaten")
		}).finally(() => {
			setLoadingKeys(prevLoadingKeys => ({ ...prevLoadingKeys, [field]: false }));
		})
	}

	const deleteRowData = (data) => {
		setShowAlert(false);

		const payload = {
			"iAdminId": data?.iAdminId
		}

		deleteRole({
			method: "post",
			data: payload
		}).then((response) => {
			if (response?.status) {
				mutate();
				setActiveRowIndex({});
				toast.success("Rol succesvol verwijderd.")
			} else {
				toast.error("Verwijderen van rol mislukt")
			}
		}).catch(() => {
			toast.error("Verwijderen van rol mislukt")
		})

	};


	return (
		<>
			<ReactTableGenericForUsers
				data={data}
				columns={columns}
				setPageNumber={setPageNumber}
				pageNumber={pageNumber}
				totalPageCount={totalPageCount}
				paginate={paginate}
				filterList={filterList}
				userTablePageSize={userTablePageSize}
				pageSizeCount={pageSizeCount}
				showLoader={isLoading}
				tableClassName="mb-0 table table-borderless table-sm table-hover"
				count={totalCount}
			/>

			{showModal && <UserModal setModal={setShowModal} modal={showModal} setRowSaved={setRowSaved} rowSaved={rowSaved} />}

			<SweetAlert title="Weet je zeker dat je wilt verwijderen?" show={showAlert}
				type="warning"
				onConfirm={() => { deleteRowData(activeRowIndex) }}
				onCancel={() => setShowAlert(false)}
				cancelBtnText="Nee"
				confirmBtnText="Ja"
				showCancel={true}
			/>
		</>
	);
};

export default List;
